import Endpoint from '../api/endpoint.js'
import { OK, INTERNAL_SERVER_ERROR, CREATED, ServerLoading} from '../util.js'

const state = {
  groups: [],
  categorys: [],
  filCategorys: [],
  group_id: null,
  apiStatus: null,
  errorMessages: null,
  newsDetails: [],
  newsList: [],
  articleUser: [],
}

const getters ={
  groups: state => state.groups ? state.groups : [],
  categorys: state => state.filCategorys ? state.filCategorys : [],
  news: state => (params) =>{
    if(params.group === '0' && params.category === '0'){
      //すべてのリストを返却
      return state.newsList
    }
    //検索パラメーターがグループのみ
    if(params.group !== '0' && params.category === '0'){
      return state.newsList.filter(news => news.group_id === params.group)
    }
    return state.newsList.filter(news => news.group_id === params.group && news.category_id === params.category)
  },
  readUsers: (state) => (index) => {
    return state.articleUser.filter(item => item.news_id === index)
  }
}

const mutations = {
  setItems(state, items){
    state.groups = items.groups
    state.categorys = items.categorys
  },
  setCategorys(state, items){
    state.filCategorys = items
  },
  setApiStatus(state, status){
    state.apiStatus = status
  },
  setErrorMessages(state, messages){
    state.errorMessages = messages
  },
  setNewsDetails(state, item){
    state.newsDetails = item
  },
  setNews(state, items){
    state.newsList = items
  },
  setArticleUser(state, items){
    state.articleUser = items
  }
}

const actions = {
  /**
   * グループが変更されたらカテゴリの絞り込みを行う
   * @param {*} context 
   * @param {*} key 
   */
  filCategorys(context, key){
    context.commit('setCategorys', context.state.categorys.filter(category => category.group_id === key))
  },
  /**
   * 記事新規作成の際のグループとカテゴリーの取得
   * @param {*} context 
   */
  async newsGroupAndCategory(context){
    //tokenが保持されている場合は認証
    context.commit('setApiStatus', null)
    context.commit('loading/setLoadingStatus', { loading: true, message: ServerLoading }, { root: true } )
    
    const auth = context.rootGetters['auth/postUser']

    await Endpoint.newsItems(auth).then(response => {
      if (response.status === OK) {
        context.commit('setApiStatus', true)
        context.commit('setItems', response.data)
        context.commit('loading/clearLoading', null, { root: true } )
        return false
      }

      //不明なエラーが発生
      context.commit('setApiStatus', false)
      context.commit('error/setCode', response.status, { root: true })
      context.commit('loading/clearLoading', null, { root: true } )

    }).catch(function(error){

      context.commit('setApiStatus', false)
      context.commit('loading/clearLoading', null, { root: true } )
      //サーバー通信エラー(通信できないとerror.responseがundefinedになるため)
      if(error.response === undefined){
        context.commit('error/setCode', INTERNAL_SERVER_ERROR, { root: true } )
      }else{
        context.commit('setErrorMessages', error.response.data.errors)
        context.commit('error/setCode', error.response.status, { root: true } )
      }
    })
  },
  /**
   * 記事とユーザー情報の紐付け取得
   * @param {*} context 
   */
  async getArticleUser(context){
    //tokenが保持されている場合は認証
    context.commit('setApiStatus', null)
    context.commit('loading/setLoadingStatus', { loading: true, message: ServerLoading }, { root: true } )
    
    const auth = context.rootGetters['auth/postUser']

    await Endpoint.getArticleUser(auth).then(response => {
      if (response.status === OK) {
        context.commit('setApiStatus', true)
        context.commit('setArticleUser', response.data.articleUsers)
        context.commit('loading/clearLoading', null, { root: true } )
        return false
      }

      //不明なエラーが発生
      context.commit('setApiStatus', false)
      context.commit('error/setCode', response.status, { root: true })
      context.commit('loading/clearLoading', null, { root: true } )

    }).catch(function(error){
      context.commit('setApiStatus', false)
      context.commit('loading/clearLoading', null, { root: true } )
      //サーバー通信エラー(通信できないとerror.responseがundefinedになるため)
      if(error.response === undefined){
        context.commit('error/setCode', INTERNAL_SERVER_ERROR, { root: true } )
      }else{
        context.commit('setErrorMessages', error.response.data.errors)
        context.commit('error/setCode', error.response.status, { root: true } )
      }
    })
  },
  /**
   * 記事新規作成の際のグループとカテゴリーの取得
   * @param {*} context 
   */
  async getAllNews(context){
    //tokenが保持されている場合は認証
    context.commit('setApiStatus', null)
    context.commit('loading/setLoadingStatus', { loading: true, message: ServerLoading }, { root: true } )
    
    const auth = context.rootGetters['auth/postUser']

    await Endpoint.getAllNews(auth).then(response => {
      if (response.status === OK) {
        context.commit('setApiStatus', true)
        context.commit('setNews', response.data.news)
        context.commit('loading/clearLoading', null, { root: true } )
        return false
      }

      //不明なエラーが発生
      context.commit('setApiStatus', false)
      context.commit('error/setCode', response.status, { root: true })
      context.commit('loading/clearLoading', null, { root: true } )

    }).catch(function(error){

      context.commit('setApiStatus', false)
      context.commit('loading/clearLoading', null, { root: true } )
      //サーバー通信エラー(通信できないとerror.responseがundefinedになるため)
      if(error.response === undefined){
        context.commit('error/setCode', INTERNAL_SERVER_ERROR, { root: true } )
      }else{
        context.commit('setErrorMessages', error.response.data.errors)
        context.commit('error/setCode', error.response.status, { root: true } )
      }
    })
  },
  /**
   * 新規お知らせ登録
   * @param {*} context 
   * @param {*} data 
   */
  async createNews(context, data){
    context.commit('setApiStatus', null)
    context.commit('loading/setLoadingStatus', { loading: true, message: ServerLoading }, { root: true } )

    const auth = context.rootGetters['auth/postUser']
    data.token = auth.token
    data.user = auth.user
    //新規お知らせ登録API
    await Endpoint.createNews(data).then(response => {
      if(response.status === CREATED){
        //成功したらtrueを代入
        context.commit('setApiStatus', true)
        context.commit('loading/clearLoading', null, { root: true } )
        return false
      }

      //不明なエラーが発生
      context.commit('setApiStatus', false)
      context.commit('error/setCode', response.status, { root: true })
      context.commit('loading/clearLoading', null, { root: true } )

    }).catch(error => {

      context.commit('setApiStatus', false)
      context.commit('loading/clearLoading', null, { root: true } )
      //サーバー通信エラー(通信できないとerror.responseがundefinedになるため)
      if(error.response === undefined){
        context.commit('error/setCode', INTERNAL_SERVER_ERROR, { root: true } )
      }else{
        context.commit('setErrorMessages', error.response.data.errors)
        context.commit('error/setCode', error.response.status, { root: true } )
      }
    })
  },
  /**
   * お知らせ編集
   * @param {*} context 
   * @param {*} data 
   */
  async editNews(context, data){
    context.commit('setApiStatus', null)
    context.commit('loading/setLoadingStatus', { loading: true, message: ServerLoading }, { root: true } )

    const auth = context.rootGetters['auth/postUser']
    data.token = auth.token
    data.user = auth.user
    //新規お知らせ登録API
    await Endpoint.editNews(data).then(response => {
      if(response.status === OK){
        //成功したらtrueを代入
        context.commit('setApiStatus', true)
        context.commit('loading/clearLoading', null, { root: true } )
        return false
      }

      //不明なエラーが発生
      context.commit('setApiStatus', false)
      context.commit('error/setCode', response.status, { root: true })
      context.commit('loading/clearLoading', null, { root: true } )

    }).catch(error => {

      context.commit('setApiStatus', false)
      context.commit('loading/clearLoading', null, { root: true } )
      //サーバー通信エラー(通信できないとerror.responseがundefinedになるため)
      if(error.response === undefined){
        context.commit('error/setCode', INTERNAL_SERVER_ERROR, { root: true } )
      }else{
        context.commit('setErrorMessages', error.response.data.errors)
        context.commit('error/setCode', error.response.status, { root: true } )
      }
    })
  },
  /**
   * お知らせ削除
   * @param {*} context 
   * @param {*} data 
   */
  async deleteNews(context, data){
    context.commit('setApiStatus', null)
    context.commit('loading/setLoadingStatus', { loading: true, message: ServerLoading }, { root: true } )

    const auth = context.rootGetters['auth/postUser']
    data.token = auth.token
    data.user = auth.user
    //新規お知らせ登録API
    await Endpoint.deleteNews(data).then(response => {
      if(response.status === OK){
        //成功したらtrueを代入
        context.commit('setApiStatus', true)
        context.commit('loading/clearLoading', null, { root: true } )
        return false
      }

      //不明なエラーが発生
      context.commit('setApiStatus', false)
      context.commit('error/setCode', response.status, { root: true })
      context.commit('loading/clearLoading', null, { root: true } )

    }).catch(error => {

      context.commit('setApiStatus', false)
      context.commit('loading/clearLoading', null, { root: true } )
      //サーバー通信エラー(通信できないとerror.responseがundefinedになるため)
      if(error.response === undefined){
        context.commit('error/setCode', INTERNAL_SERVER_ERROR, { root: true } )
      }else{
        context.commit('setErrorMessages', error.response.data.errors)
        context.commit('error/setCode', error.response.status, { root: true } )
      }
    })
  },
  /**
   * 新規グループ追加
   * @param {*} context 
   * @param {*} data 
   */
  async createGroup(context, data){
    context.commit('setApiStatus', null)
    context.commit('loading/setLoadingStatus', { loading: true, message: ServerLoading }, { root: true } )

    const auth = context.rootGetters['auth/postUser']
    data.token = auth.token
    data.user = auth.user
    //新規グループ登録API
    await Endpoint.createGroup(data).then(response => {
      if(response.status === CREATED){
        //成功したらtrueを代入
        context.commit('setApiStatus', true)
        context.commit('loading/clearLoading', null, { root: true } )
        return false
      }

      //不明なエラーが発生
      context.commit('setApiStatus', false)
      context.commit('error/setCode', response.status, { root: true })
      context.commit('loading/clearLoading', null, { root: true } )

    }).catch(error => {
      context.commit('setApiStatus', false)
      context.commit('loading/clearLoading', null, { root: true } )
      //サーバー通信エラー(通信できないとerror.responseがundefinedになるため)
      if(error.response === undefined){
        context.commit('error/setCode', INTERNAL_SERVER_ERROR, { root: true } )
      }else{
        context.commit('setErrorMessages', error.response.data.errors)
        context.commit('error/setCode', error.response.status, { root: true } )
      }
    })
  },
  /**
   * グループ削除
   * @param {*} context 
   * @param {*} data 
   */
  async deleteGroup(context, data){
    context.commit('setApiStatus', null)
    context.commit('loading/setLoadingStatus', { loading: true, message: ServerLoading }, { root: true } )

    const auth = context.rootGetters['auth/postUser']
    data.token = auth.token
    data.user = auth.user
    //新規グループ登録API
    await Endpoint.deleteGroup(data).then(response => {
      if(response.status === OK){
        //成功したらtrueを代入
        context.commit('setApiStatus', true)
        context.commit('loading/clearLoading', null, { root: true } )
        return false
      }

      //不明なエラーが発生
      context.commit('setApiStatus', false)
      context.commit('error/setCode', response.status, { root: true })
      context.commit('loading/clearLoading', null, { root: true } )

    }).catch(error => {
      context.commit('setApiStatus', false)
      context.commit('loading/clearLoading', null, { root: true } )
      //サーバー通信エラー(通信できないとerror.responseがundefinedになるため)
      if(error.response === undefined){
        context.commit('error/setCode', INTERNAL_SERVER_ERROR, { root: true } )
      }else{
        context.commit('setErrorMessages', error.response.data.errors)
        context.commit('error/setCode', error.response.status, { root: true } )
      }
    })
  },
  /**
   * グループ名称変更
   * @param {*} context 
   * @param {*} data 
   */
  async editGroup(context, data){
    context.commit('setApiStatus', null)
    context.commit('loading/setLoadingStatus', { loading: true, message: ServerLoading }, { root: true } )

    const auth = context.rootGetters['auth/postUser']
    data.token = auth.token
    data.user = auth.user
    //グループ編集登録API
    await Endpoint.editGroup(data).then(response => {
      if(response.status === OK){
        //成功したらtrueを代入
        context.commit('setApiStatus', true)
        context.commit('loading/clearLoading', null, { root: true } )
        return false
      }

      //不明なエラーが発生
      context.commit('setApiStatus', false)
      context.commit('error/setCode', response.status, { root: true })
      context.commit('loading/clearLoading', null, { root: true } )

    }).catch(error => {
      context.commit('setApiStatus', false)
      context.commit('loading/clearLoading', null, { root: true } )
      //サーバー通信エラー(通信できないとerror.responseがundefinedになるため)
      if(error.response === undefined){
        context.commit('error/setCode', INTERNAL_SERVER_ERROR, { root: true } )
      }else{
        context.commit('setErrorMessages', error.response.data.errors)
        context.commit('error/setCode', error.response.status, { root: true } )
      }
    })
  },
  /**
   * 新規カテゴリ追加
   * @param {*} context 
   * @param {*} data 
   */
  async createCategory(context, data){
    context.commit('setApiStatus', null)
    context.commit('loading/setLoadingStatus', { loading: true, message: ServerLoading }, { root: true } )

    const auth = context.rootGetters['auth/postUser']
    data.token = auth.token
    data.user = auth.user
    //新規カテゴリ登録API
    await Endpoint.createCategory(data).then(response => {
      if(response.status === CREATED){
        //成功したらtrueを代入
        context.commit('setApiStatus', true)
        context.commit('loading/clearLoading', null, { root: true } )
        return false
      }

      //不明なエラーが発生
      context.commit('setApiStatus', false)
      context.commit('error/setCode', response.status, { root: true })
      context.commit('loading/clearLoading', null, { root: true } )

    }).catch(error => {
      context.commit('setApiStatus', false)
      context.commit('loading/clearLoading', null, { root: true } )
      //サーバー通信エラー(通信できないとerror.responseがundefinedになるため)
      if(error.response === undefined){
        context.commit('error/setCode', INTERNAL_SERVER_ERROR, { root: true } )
      }else{
        context.commit('setErrorMessages', error.response.data.errors)
        context.commit('error/setCode', error.response.status, { root: true } )
      }
    })
  },
  /**
   * カテゴリ名称変更
   * @param {*} context 
   * @param {*} data 
   */
  async editCategory(context, data){
    context.commit('setApiStatus', null)
    context.commit('loading/setLoadingStatus', { loading: true, message: ServerLoading }, { root: true } )

    const auth = context.rootGetters['auth/postUser']
    data.token = auth.token
    data.user = auth.user
    //カテゴリ編集登録API
    await Endpoint.editCategory(data).then(response => {
      if(response.status === OK){
        //成功したらtrueを代入
        context.commit('setApiStatus', true)
        context.commit('loading/clearLoading', null, { root: true } )
        return false
      }

      //不明なエラーが発生
      context.commit('setApiStatus', false)
      context.commit('error/setCode', response.status, { root: true })
      context.commit('loading/clearLoading', null, { root: true } )

    }).catch(error => {
      context.commit('setApiStatus', false)
      context.commit('loading/clearLoading', null, { root: true } )
      //サーバー通信エラー(通信できないとerror.responseがundefinedになるため)
      if(error.response === undefined){
        context.commit('error/setCode', INTERNAL_SERVER_ERROR, { root: true } )
      }else{
        context.commit('setErrorMessages', error.response.data.errors)
        context.commit('error/setCode', error.response.status, { root: true } )
      }
    })
  },
  /**
   * ニュース詳細取得
   * @param {*} context 
   * @param {*} data 
   */
  async getNewsDetails(context, data){
    context.commit('setApiStatus', null)
    context.commit('loading/setLoadingStatus', { loading: true, message: ServerLoading }, { root: true } )

    const auth = context.rootGetters['auth/postUser']
    data.token = auth.token
    data.user = auth.user
    //カテゴリ編集登録API
    await Endpoint.getNewsDetails(data).then(response => {
      if(response.status === OK){
        //成功したらtrueを代入
        context.commit('setApiStatus', true)
        context.commit('setNewsDetails',response.data.news)
        context.commit('loading/clearLoading', null, { root: true } )
        return false
      }

      //不明なエラーが発生
      context.commit('setApiStatus', false)
      context.commit('error/setCode', response.status, { root: true })
      context.commit('loading/clearLoading', null, { root: true } )

    }).catch(error => {
      context.commit('setApiStatus', false)
      context.commit('loading/clearLoading', null, { root: true } )
      //サーバー通信エラー(通信できないとerror.responseがundefinedになるため)
      if(error.response === undefined){
        context.commit('error/setCode', INTERNAL_SERVER_ERROR, { root: true } )
      }else{
        context.commit('setErrorMessages', error.response.data.errors)
        context.commit('error/setCode', error.response.status, { root: true } )
      }
    })
  },
  /**
   * ドライバーニュース詳細確認
   * @param {*} context 
   * @param {*} data 
   */
  async readDetials(context, data){
    context.commit('setApiStatus', null)
    context.commit('loading/setLoadingStatus', { loading: true, message: ServerLoading }, { root: true } )

    const auth = context.rootGetters['auth/postUser']
    data.token = auth.token
    data.user = auth.user
    //ドライバーニュース詳細確認
    await Endpoint.readDetials(data).then(response => {
      if(response.status === OK){
        //成功したらtrueを代入
        context.commit('setApiStatus', true)
        context.commit('loading/clearLoading', null, { root: true } )
        return false
      }

      //不明なエラーが発生
      context.commit('setApiStatus', false)
      context.commit('error/setCode', response.status, { root: true })
      context.commit('loading/clearLoading', null, { root: true } )

    }).catch(error => {
      context.commit('setApiStatus', false)
      context.commit('loading/clearLoading', null, { root: true } )
      //サーバー通信エラー(通信できないとerror.responseがundefinedになるため)
      if(error.response === undefined){
        context.commit('error/setCode', INTERNAL_SERVER_ERROR, { root: true } )
      }else{
        context.commit('setErrorMessages', error.response.data.errors)
        context.commit('error/setCode', error.response.status, { root: true } )
      }
    })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}